import { useCurrency } from "@/context/CurrencyContext";
import { CreditCard, Apple } from "lucide-react";

const Pill = ({ children, testid }) => (
  <span
    data-testid={testid}
    className="inline-flex items-center gap-1.5 border border-white/15 px-3 py-1.5 font-mono-label text-[9px] uppercase tracking-luxe text-white/55"
  >
    {children}
  </span>
);

export default function PaymentBadges({ className = "" }) {
  const { currency } = useCurrency();
  return (
    <div data-testid="payment-badges" className={`flex flex-wrap items-center justify-center gap-2 ${className}`}>
      <Pill testid="badge-card">
        <CreditCard size={12} strokeWidth={1.5} /> Card
      </Pill>
      <Pill testid="badge-apple-pay">
        <Apple size={12} strokeWidth={1.5} className="-mt-px" /> Pay
      </Pill>
      {currency === "chf" && (
        <Pill testid="badge-twint">
          <span className="text-white/70 font-semibold tracking-normal normal-case">twint</span>
        </Pill>
      )}
    </div>
  );
}
